import { NormalButton } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import type { CreateOrderSheetArgs } from '../../type/common.type';
import type { ConfirmButtonItem } from '../../type/common.type';
import { KakaoPurchaseButton } from './parts/KakaoPurchaseButton';

export interface ConfirmButtonProps {
  payload: CreateOrderSheetArgs;
  buttons: ConfirmButtonItem[] | React.ReactNode;
}

export const ConfirmButton = ({ payload, buttons }: ConfirmButtonProps) => {
  if (!Array.isArray(buttons)) {
    return <>{buttons}</>;
  }

  return (
    <Container>
      {buttons.map((item, index) => (
        <ButtonWrapper key={index}>
          {item.variant === 'kakao' ? (
            <KakaoPurchaseButton text={item.text} handleClick={() => item.action(payload)} />
          ) : (
            <NormalButton
              disabled={item.disabled}
              fullWidth
              variant={item.variant}
              size='large'
              style={item.style}
              onClick={() => item.action(payload)}
            >
              {item.text}
            </NormalButton>
          )}
        </ButtonWrapper>
      ))}
    </Container>
  );
};

const Container = styled.div`
  margin: 28px 0 10px 0;
  padding: 0 16px;
  display: flex;
  justify-content: center;
  column-gap: 7px;
`;

const ButtonWrapper = styled.div`
  flex: 1;
`;
